import React, { useState, useEffect } from 'react';
import { Menu, X, FileDown } from 'lucide-react';
import { PERSONAL_INFO } from '../data/content';
import { assetUrl } from '../utils/assetUrl';

export const Navbar: React.FC = () => {
  const [scrolled, setScrolled] = useState(false);
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);

  useEffect(() => {
    const handleScroll = () => setScrolled(window.scrollY > 30);
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const navLinks = [
    { label: "Research", href: "#research" },
    { label: "Publications", href: "#publications" },
    { label: "Production AI", href: "#enterprise-ai" },
    { label: "Experience", href: "#industry" },
    { label: "Vision", href: "#vision" },
    { label: "Credentials", href: "#credentials" },
    { label: "Documents", href: "#documents" },
  ];

  return (
    <header className={`fixed top-0 left-0 right-0 z-40 transition-all duration-500 ${
      scrolled
        ? 'bg-paper-50/95 backdrop-blur-md border-b border-ink-100 py-3 shadow-[0_1px_12px_rgba(20,33,61,0.05)]'
        : 'bg-transparent py-5'
    }`}>
      <div className="max-w-6xl mx-auto px-5 sm:px-8">
        <div className="flex items-center justify-between">
          {/* Name mark */}
          <a href="#top" className="group flex items-baseline gap-2">
            <span className="font-serif text-lg font-bold text-ink-900 tracking-tight group-hover:text-accent-700 transition-colors">
              Rafi Imam
            </span>
            <span className="hidden sm:inline text-[11px] font-mono text-brass-600 tracking-wide">
              Ph.D. Applicant ’27
            </span>
          </a>

          {/* Desktop nav */}
          <nav className="hidden md:flex items-center gap-1">
            {navLinks.map((link) => (
              <a
                key={link.href}
                href={link.href}
                className="px-3 py-1.5 text-[13px] font-medium text-slate-500 hover:text-ink-900 rounded-lg hover:bg-paper-200/70 transition-all"
              >
                {link.label}
              </a>
            ))}
          </nav>

          {/* Right actions */}
          <div className="flex items-center gap-3">
            <a
              href={assetUrl('./docs/MD_RAFI_IMAM_CV.pdf')}
              download
              className="hidden sm:flex items-center gap-1.5 px-3.5 py-1.5 text-xs font-semibold text-white bg-ink-900 hover:bg-ink-800 rounded-lg transition-all"
            >
              <FileDown className="w-3.5 h-3.5" />
              <span>Download CV</span>
            </a>

            <button
              onClick={() => setMobileMenuOpen(!mobileMenuOpen)}
              className="md:hidden p-2 text-slate-500 hover:text-ink-900 bg-white border border-ink-100 rounded-lg"
              aria-label="Toggle menu"
            >
              {mobileMenuOpen ? <X className="w-5 h-5" /> : <Menu className="w-5 h-5" />}
            </button>
          </div>
        </div>
      </div>

      {/* Mobile dropdown */}
      {mobileMenuOpen && (
        <div className="md:hidden bg-paper-50/98 backdrop-blur-xl border-b border-ink-100 mt-1 px-5 py-4">
          <div className="space-y-1">
            {navLinks.map((link) => (
              <a
                key={link.href}
                href={link.href}
                onClick={() => setMobileMenuOpen(false)}
                className="block px-3 py-2 text-sm text-slate-600 hover:text-ink-900 hover:bg-paper-200/70 rounded-lg transition"
              >
                {link.label}
              </a>
            ))}
          </div>
          <div className="mt-4 pt-3 border-t border-ink-100 flex gap-3">
            <a href={PERSONAL_INFO.scholarUrl} target="_blank" rel="noopener noreferrer" className="text-xs text-slate-500 hover:text-accent-700 transition">Scholar</a>
            <a href={PERSONAL_INFO.researchGateUrl} target="_blank" rel="noopener noreferrer" className="text-xs text-slate-500 hover:text-accent-700 transition">ResearchGate</a>
            <a href={PERSONAL_INFO.githubUrl} target="_blank" rel="noopener noreferrer" className="text-xs text-slate-500 hover:text-accent-700 transition">GitHub</a>
          </div>
        </div>
      )}
    </header>
  );
};
